import { api as wiredApi } from './index';

/**
 * Each side of a delivery rates the other, once, after it is completed, on
 * InGo's API (ingo-e0, 2 Oct 2026; InGo ADR 0029). The old screens wrote to
 * Supabase's `trip_reviews` from the browser, any row by anyone, as often as
 * they liked.
 *
 * `side` is the realm's prefix: `/customer` (the client rates the rider) or
 * `/rider` (the rider rates the client). A second rating answers 409
 * `ALREADY_RATED`, which a screen reads as sent: it is the retry after a lost
 * answer. Built from its client so a test can hand it a fake.
 */
export function createRatings({ api, side }) {
  const path = (deliveryId) => `${side}/me/deliveries/${encodeURIComponent(deliveryId)}/rating`;

  return {
    /** Whether this side may rate the delivery now, why not, who is rated, and the rating once given. */
    async state(deliveryId) {
      const { data } = await api.get(path(deliveryId));

      return data;
    },

    /** One to five stars, the client's chips by key, a comment for the office only. */
    async rate(deliveryId, { stars, tags = [], comment = '' }) {
      const body = { stars };
      if (tags.length > 0) body.tags = tags;
      if (String(comment).trim() !== '') body.comment = String(comment).trim();
      const { message } = await api.post(path(deliveryId), body);

      return message;
    },
  };
}

export const clientRatings = createRatings({ api: wiredApi, side: '/customer' });
export const riderRatings = createRatings({ api: wiredApi, side: '/rider' });
